export const validCompanyNameRegex = /^[\w &',./-]+$/;
